import { styled } from '@mui/material';
import * as React from 'react';

import { MLLogoSVG } from './ml-logo-svg';

const Container = styled('div')({
    minHeight: '100vh',
    backgroundImage:
        'linear-gradient(169deg, #4977dd 28%, rgba(51, 192, 230, 0.75))',
    width: '300px',
    position: 'relative',
    overflow: 'hidden'
});

const Logo1 = styled(MLLogoSVG)({
    position: 'absolute',
    top: '40%',
    left: '50%',
    marginLeft: '-100px',
    marginTop: '-140px',
    fontSize: '200px',
    color: 'white',
    opacity: 0.2
});

const Logo2 = styled(MLLogoSVG)({
    position: 'absolute',
    top: '45%',
    left: '-195px',
    marginTop: '-60px',
    fontSize: '390px',
    color: 'white',
    opacity: 0.2
});

export const SignupSidebar = () => {
    return (
        <Container>
            <Logo1 />
            <Logo2 />
        </Container>
    );
};
